import { createContext, useContext } from 'react'

export const NotificationsPatientGroupContext = createContext<any>({})

export const useNotificationsPatientGroupContext = () => {
  const context = useContext(NotificationsPatientGroupContext)
  return context
}
